<template>
  <v-row no-gutters>
    <v-col cols="5" xl="5" lg="6" md="12">
      <InputsTree :inputs="inputsData" :data="data" />
    </v-col>
    <v-col cols="7" xl="7" lg="6" md="12">
      <h4>{{ $t("strings.concatenate-strings") }}</h4>
      <h6>{{ $t("strings.select-strings-and-separator") }}</h6>
      <v-sheet
        class="overflow-y-auto pt-4"
        :max-height="data.parentContentHeight"
      >
        <v-form ref="form" v-model="valid" lazy-validation class="pa-2">
          <v-sheet>
            <v-row dense>
              <v-col cols="12">
                <InputBlock :paramValues="paramsObj_1" />
              </v-col>
              <v-col cols="12">
                <InputBlock :paramValues="paramsSeparator" />
              </v-col>
              <v-col cols="12" text-center>
                <InputBlock :paramValues="paramsObj_2" />
              </v-col>
            </v-row>
          </v-sheet>
        </v-form>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { inject, provide, reactive, toRefs, watch, computed } from "vue";
import { retrievesParameters } from "@/mixins/common-utils.js";
import InputsTree from "../blocks/InputsListTree.vue";
import InputBlock from "../blocks/InputBlock.vue";

export default {
  name: "OperatorConcatenateStrings",
  props: ["target", "data", "operatorInputs"],
  emits: ["updateFormData"],
  components: {
    InputsTree,
    InputBlock,
  },
  setup(props, { emit }) {
    const valid = inject("valid");
    //Creates a deep copy, unlinked of target.userData
    const formData = reactive(
      JSON.parse(JSON.stringify(props.target.userData)) || {},
    );
    provide("formData", formData);

    //Retrieves Operator parameters
    const paramsObj_1 = retrievesParameters(
      "obj_1",
      props.target.userData.parameters,
    );
    const paramsObj_2 = retrievesParameters(
      "obj_2",
      props.target.userData.parameters,
    );
    const paramsSeparator = retrievesParameters(
      "separator",
      props.target.userData.parameters,
    );
    //Sets Operator parameters labels
    paramsObj_1.label = "labels.string1";
    paramsObj_2.label = "labels.string2";
    paramsSeparator.label = "labels.separator";

    watch(
      formData,
      (newFormData) => {
        emit("updateFormData", newFormData);
      },
      { deep: true, immediate: true },
    );

    let inputsData = computed(() => {
      return props.operatorInputs;
    });

    return {
      valid,
      inputsData,
      formData,
      ...toRefs(formData),
      paramsObj_1,
      paramsObj_2,
      paramsSeparator,
    };
  },
};
</script>
